<template>
	<div class="info">
		<el-descriptions :column="1">
			<el-descriptions-item direction="vertical" label-align="right" v-for="(item, index) in mapping"
				label-width="100" :key="index" :label="item.label">
				<span v-if="
					(dataList[item.value] != '' && dataList[item.value] != null) ||
					dataList[item.value] == 0
				">
					<span v-if="item.label == '头像'">
						<MyImage :pic="dataList.avatar_url"></MyImage>
					</span>
					<span v-else-if="item.label == '性别'">
						{{ dataList[item.value] == 1 ? '男' : '女' }}
					</span>
					<span v-else-if="item.label == '学历'">
						{{
							dataList[item.value] == 0
								? '未知'
								: dataList[item.value] == 5
									? '小学'
									: dataList[item.value] == 10
										? '初中'
										: dataList[item.value] == 15
											? '高中'
											: dataList[item.value] == 20
												? '中专'
												: dataList[item.value] == 25
													? '大专'
													: dataList[item.value] == 30
														? '本科'
														: dataList[item.value] == 35
															? '研究生'
															: dataList[item.value] == 40
																? '博士'
																: '-'
						}}
					</span>
					<span v-else-if="item.label == '婚姻状态'">
						{{ dataList[item.value] == 0 ? '未婚' : '已婚' }}
					</span>
					<span v-else-if="item.label == '个人微信'">
						<MyImage :pic="dataList.wechat_url"></MyImage>
					</span>
					<span v-else-if="item.label == 'ima客户端ID'">
						{{ dataList[item.value] == '' ? '-' : '**********' }}
					</span>
					<span v-else-if="item.label == 'ima密钥'">
						{{ dataList[item.value] == '' ? '-' : '**********' }}
					</span>
					<span v-else>
						{{ dataList[item.value] }}
					</span>
				</span>
				<span v-else>-</span>
			</el-descriptions-item>
		</el-descriptions>
	</div>
</template>

<script setup>
import { ref, watch } from 'vue'
import MyImage from '@/components/common/proImage'

// Props
const props = defineProps({
	info: {
		type: Object
	}
})

// Reactive data
const dataList = ref({})
const mapping = ref([
	{
		label: '头像',
		value: 'avatar_url'
	},
	{
		label: '姓名',
		value: 'name'
	},
	{
		label: '性别',
		value: 'sex'
	},
	{
		label: '职位名称',
		value: 'posts_name'
	},
	{
		label: '业绩所属校区',
		value: 'dept'
	},
	{
		label: '最高所属部门',
		value: 'max_dept'
	},
	{
		label: '生日',
		value: 'birthday'
	},
	{
		label: '工号',
		value: 'work_no'
	},
	{
		label: '手机号',
		value: 'mobile_phone'
	},
	{
		label: '身份证号',
		value: 'idcard'
	},
	{
		label: '邮箱',
		value: 'email'
	},
	{
		label: '学历',
		value: 'degree'
	},
	{
		label: '婚姻状态',
		value: 'marital_status'
	},
	{
		label: '身高',
		value: 'height'
	},
	{
		label: '体重',
		value: 'weight'
	},
	{
		label: '家庭住址',
		value: 'family_address'
	},
	{
		label: '毕业院校',
		value: 'school'
	},
	{
		label: '行政区域编码',
		value: 'region_code'
	},
	{
		label: '优惠码',
		value: 'coupon_code'
	},
	{
		label: 'APP推广码',
		value: 'promote_url'
	},
	{
		label: '个人微信',
		value: 'wechat_url'
	},
	{
		label: 'ima客户端ID',
		value: 'client_id'
	},
	{
		label: 'ima密钥',
		value: 'api_key'
	}
])

// Watch
watch(
	() => props.info,
	(outside_prop_new) => {
		dataList.value = outside_prop_new
	},
	{ deep: true, immediate: true }
)
</script>

<style scoped></style>
